import { useQuery } from './useQuery'
import { useParams } from 'react-router-dom'

export function useUserId() {
  const userIdFromQuery = useQuery().get('userId')
  let { id } = useParams()

  return userIdFromQuery || id
}
